import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../../common/utilities/sizeHelpers';
import { StoryReadMore } from './storyReadMore';
import { StoryThumbnail } from './storyThumbnail';
import { StoryTextParser } from './storyTextParser';
import { topStoriesNewsRoutes } from '../../../common/translation/translate';

export const MainStory = memo(({ 
    nodeAlias, 
    thumbnailImageLink, 
    videoLink, 
    storyTitle, 
    storyText,
    enableSourceParameterOnStoriesLinks,
    source
}) => {
    let newsDetailLink = `${topStoriesNewsRoutes.news}${nodeAlias}`;
    if (enableSourceParameterOnStoriesLinks) {
        newsDetailLink = `${location.origin}${newsDetailLink}?source=${source}`;
    }

    return(
        <Container >
            {enableSourceParameterOnStoriesLinks 
                ? <LinkWrapper href={newsDetailLink} target='_self'>
                    <ImageContainer>
                        <StoryThumbnail storyImageUrl={thumbnailImageLink} hasVideoLinkUrl={videoLink?.[0]?.Url}  />
                    </ImageContainer>
                    <BodyContainer>
                        {storyTitle && <StoryTitle>{storyTitle}</StoryTitle>}
                        {storyText && <StoryText>
                            <StoryTextParser storyText={storyText} />
                        </StoryText>}
                    </BodyContainer>
                    <StoryReadMore translateKey='readMore' isFirstStory={true} link={`${topStoriesNewsRoutes.news}${nodeAlias}`} />
                </LinkWrapper>
                : <LinkWrapper href={newsDetailLink}>
                    <ImageContainer>
                        <StoryThumbnail storyImageUrl={thumbnailImageLink} hasVideoLinkUrl={videoLink?.[0]?.Url}  />
                    </ImageContainer>
                    <BodyContainer>
                        {storyTitle && <StoryTitle>{storyTitle}</StoryTitle>}
                        {storyText && <StoryText>
                            <StoryTextParser storyText={storyText} />
                        </StoryText>}
                    </BodyContainer>
                    <StoryReadMore translateKey='readMore' isFirstStory={true} link={`${topStoriesNewsRoutes.news}${nodeAlias}`} />
                </LinkWrapper>
            }
        </Container>
    );
});

MainStory.displayName = 'MainStory';

MainStory.propTypes = {
    nodeAlias: PropTypes.string,
    thumbnailImageLink: PropTypes.string,
    videoLink: PropTypes.string,
    storyTitle: PropTypes.string,
    storyText: PropTypes.string
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #ffffff;
    height: 100%;
    width: 58%;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    @media screen and ${largeMediaQuery} {
        padding-right: 0px;
    }

    @media screen and ${mediumMediaQuery} {
        min-height: 370px;
        height: 370px;
        margin-bottom: 10px;
        width: 100%;
    }

    @media screen and ${smallMediaQuery} {
        min-height: 406px;
        height: 406px;
        width: 100%;
        margin-bottom: 10px;
    }
`;

const LinkWrapper = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    text-decoration: none;
`;

const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 53%;
    @media screen and ${mediumMediaQuery} {
        height: 58%;
    }

    @media screen and ${smallMediaQuery} {
        height: 58%;
        width: 100%;
    }
`;

const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    background-color: #ffffff;
    height: 41%;
    width: 100%;
    @media screen and ${mediumMediaQuery} {
        height: 35%;
    }

    @media screen and ${smallMediaQuery} {
        height: 35%;
        justify-content: space-between;
    }
`;

const StoryTitle = styled.div`
    display: box;
    display: -webkit-box;
    align-items: left;
    line-height: 1.5;
    -webkit-line-clamp: 3;
    color: #666666;
    font-weight: 600;
    text-transform: capitalize;
    -webkit-box-orient: vertical;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    width: 100%;
    font-size: 16px;
    height: 30%;
    @media ${largeMediaQuery} {
        font-size: 18px;
        height: 25%;
    }
`;

const StoryText = styled.div`
    display: flex;
    line-height: 24px;
    width: 100%;
    color: #666;
    height: 70%;
    overflow: hidden;
    @media ${mediumMediaQuery} {
        height: auto;
    }
    @media ${largeMediaQuery} {
        height: auto;
    }
`;

